<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0003 18.3334C12.3015 18.3334 14.3848 17.4007 15.8929 15.8926C17.4009 14.3846 18.3337 12.3012 18.3337 10.0001C18.3337 7.69892 17.4009 5.61558 15.8929 4.10752C14.3848 2.59949 12.3015 1.66675 10.0003 1.66675C7.69916 1.66675 5.61583 2.59949 4.10777 4.10752C2.59973 5.61558 1.66699 7.69892 1.66699 10.0001C1.66699 12.3012 2.59973 14.3846 4.10777 15.8926C5.61583 17.4007 7.69916 18.3334 10.0003 18.3334Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.8867 6.87725C14.2306 7.18301 14.2616 7.70974 13.9559 8.05373L9.51141 13.0537C9.35327 13.2316 9.1266 13.3334 8.88857 13.3334C8.65054 13.3334 8.42387 13.2316 8.26573 13.0537L6.04351 10.5537C5.73774 10.2097 5.76873 9.68301 6.11271 9.37725C6.4567 9.07148 6.98343 9.10247 7.28919 9.44645L8.88857 11.2458L12.7102 6.94645C13.0159 6.60247 13.5427 6.57148 13.8867 6.87725Z"
      fill="white"
    />
  </svg>
</template>
